import React from 'react'
import Map from "../Map/map";
import PageLayout from "../pagelayout"
import UpdateProfile from "./updateprofile"

const ProfilePage = () => {
    return (
        <PageLayout bgWhite Map={Map}>
            <UpdateProfile />
        </PageLayout>
    )
}

export default ProfilePage
